import { Typography, Box } from "@mui/material";


const SectionHeader = ({ id, text }) => {

    return <section id={id}>
        <Box sx={{
            mt: 6,
            display: "flex",
            flexDirection: "column"
        }}>
            <Typography
                ml={{ xs: "0px", sm: "5%" }}
                alignSelf={{ xs: "center", sm: "flex-start" }}
                sx={{
                    fontSize: { xs: "20px", sm: "36px" },
                    fontWeight: "bold",
                    textShadow: "0px 0px 2px grey"
                }}
            >
                {text}
            </Typography>

            <Box
                sx={{ borderRadius: "12px" }}
                bgcolor="black"
                height="3px"
                width="95%"
                alignSelf="center"
                mt={1}
            />
        </Box>
    </section>
}

export default SectionHeader;